import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Raffle } from '@core/models/raffle.model';
import { GtmService } from '@core/services/gtm/gtm.service';
import { Select } from '@ngxs/store';
import { ProjectDataService } from '@core/services/project-data/project-data.service';
import { CartState, CartStateModel } from '@store/cart/cart.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-product-dialog',
  templateUrl: './product-dialog.component.html',
  styleUrls: ['./product-dialog.component.scss']
})
export class ProductDialogComponent implements OnDestroy {
  cartNonEmpty: boolean;
  productPagePath = 'product';
  cartPagePath = 'cart';

  private _alive$ = new Subject<void>();

  @Select(CartState.state) cart$: Observable<CartStateModel>;
  constructor(
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      product: Raffle;
      tickets: number;
      projectCode: string;
      text: string;
    },
    private gtm: GtmService,
    private projectDataService: ProjectDataService
  ) {
    this.productPagePath = this.projectDataService.get('product_page_path');
    this.cartPagePath = this.projectDataService.get('cart_page_path');
    this.cart$.pipe(takeUntil(this._alive$)).subscribe(cartState => {
      if (!cartState.cart) {
        return;
      }

      this.cartNonEmpty = cartState.cart.items.length === 1 ? true : false;
    });
  }

  ngOnDestroy(): void {
    this._alive$.next();
    this._alive$.complete();
  }

  enterNowCrossSell(targetId) {
    if (!targetId || !this.data.product) {
      return;
    }

    this.gtm.crossSellEnterNow(targetId, this.data.product.id);
  }
}
